import { DEPLOYMENT_DOMAIN, DeploymentEnvironment } from '@env';
import { ComposeAnalytics } from './compose';
import { consoleAnalytics } from './console';
import { SegmentAnalytics } from './segment-analytics';
import { zarazAnalytics } from './zaraz-analytics';
export * as helpers from './helpers';

const destinations = [];

if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'test') {
  // All environments
  destinations.push(zarazAnalytics);

  // Development only - including non-dev deployments.
  if (process.env.NODE_ENV === 'development') {
    destinations.push(consoleAnalytics);
  }

  // Production Only
  if ([DeploymentEnvironment.Production].includes(DEPLOYMENT_DOMAIN)) {
    const segment = new SegmentAnalytics();
    destinations.push(segment);
  }
}

export const analytics = new ComposeAnalytics(destinations);
